import { render, staticRenderFns } from "./CardGame.vue?vue&type=template&id=4bfc1b5c&lang=pug&"
import script from "./CardGame.vue?vue&type=script&lang=js&"
export * from "./CardGame.vue?vue&type=script&lang=js&"
import style0 from "./CardGame.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielrubiocastillo/Documents/workspaces/emaraplay/lobby-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bfc1b5c')) {
      api.createRecord('4bfc1b5c', component.options)
    } else {
      api.reload('4bfc1b5c', component.options)
    }
    module.hot.accept("./CardGame.vue?vue&type=template&id=4bfc1b5c&lang=pug&", function () {
      api.rerender('4bfc1b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardGame.vue"
export default component.exports